import React, { useMemo } from 'react';

const toWeightOptions = (variants = []) => {
  const values = variants.map((variant) => {
    if (variant === 'regular') return '400';
    if (variant === 'italic') return '400';
    return String(variant).replace('italic', '') || '400';
  });

  return Array.from(new Set(values.filter((value) => /^\d+$/.test(value)))).sort((a, b) => Number(a) - Number(b));
};

export function FontWeightSelector({ fonts, selectedFamily, value, onChange }) {
  const selectedFont = useMemo(
    () => (fonts || []).find((item) => item.family === selectedFamily) || null,
    [fonts, selectedFamily]
  );

  const options = useMemo(() => toWeightOptions(selectedFont?.variants || []), [selectedFont]);

  return (
    <div className="mp-font-picker-weight">
      <span>Peso:</span>
      <div className="mp-font-picker-weight__buttons">
        {(options.length ? options : ['400', '500', '700', '900']).map((weight) => (
          <button
            key={weight}
            type="button"
            className={`mp-font-picker-weight__btn ${String(value) === String(weight) ? 'is-active' : ''}`}
            onClick={() => onChange(weight)}
          >
            {weight === '400' ? 'Regular' : weight}
          </button>
        ))}
      </div>
    </div>
  );
}

export default FontWeightSelector;
